/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { SetThesisReactionResponse, SetThesisReactionVars } from '../openapi-types.gen.js';

export type { SetThesisReactionResponse, SetThesisReactionVars } from '../openapi-types.gen.js';

export const useSetThesisReaction = createMutationHook<SetThesisReactionVars, SetThesisReactionResponse, unknown>({
  specName: 'useSetThesisReaction',
  path: '/v1/theses/{signature}/reaction',
  method: 'PUT',
  resolveUrl: (vars: SetThesisReactionVars) => `/v1/theses/${vars.signature}/reaction`,
  buildBody: (vars: SetThesisReactionVars) => ({ kind: vars.kind }),
  parseResponse: (raw: unknown): SetThesisReactionResponse => raw as SetThesisReactionResponse,
  optimistic: [{
    queryKey: ['theses', 'detail'],
    apply: (prev: any, vars: SetThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyThesisReactionOptimistic as unknown as (prev: any, vars: SetThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }, {
    queryKey: ['theses', 'list'],
    apply: (prev: any, vars: SetThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyThesisReactionOptimistic as unknown as (prev: any, vars: SetThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
